exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#payment_cash_modal .fc-event[data-v-50e3c516] {\n   background-color:red !important;\n}\n\n", ""]);

// exports
